<script>
import { deliveryInfoProps, useDeliveryInfo } from "./mixin";

import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import SecuredDownloadButton from "@/containers/secured-download-button";
import Divider from "@/components/atoms/divider";
import scanQrcode from "@/assets/icons/scan-qrcode.svg";
import scanBonRetrait from "@/assets/icons/scan-bon-retrait.svg";

export default {
  name: "OrderConfirmationDeliveryInfoPrp",
  components: {
    SecuredDownloadButton,
    LazyImage,
    List,
    ListItem,
    Divider
  },
  props: {
    ...deliveryInfoProps()
  },
  setup(props) {
    const { printFile } = useDeliveryInfo(props);

    const Button = defineAsyncComponent(() =>
      import("@/components/atoms/button")
    );

    return { printFile, scanBonRetrait, scanQrcode, Button };
  }
};
</script>

<template>
  <div class="u-border-grey-4 u-p-md u-radius-sm u-mb-md">
    <h2 class="u-font-24 u-color-primary u-mb-sm">
      Comment retirer votre commande au drive piéton
    </h2>
    <Divider
      dotted
      size="sm"
      class="u-mb-md"
    />

    <List class="c-order-confirmation__delivery-list">
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanBonRetrait"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Présentez votre bon de retrait
          </p>
          <p class="u-font-15 u-font-secondary">
            Votre n° de commande se trouve sur celui-ci<br>{{ code }}<br>
            <SecuredDownloadButton
              :component="Button"
              link
              :secured-link="pdfUrl"
              @download="printFile"
            >
              Imprimer le bon de retrait
            </SecuredDownloadButton>
          </p>
        </div>
      </ListItem>

      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanQrcode"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Présentez un justificatif d'identité
          </p>
          <p class="u-font-15 u-font-secondary">
            Carte d'identité, passeport ou tout autre justificatif
          </p>
        </div>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/order-confirmation.scss";
</style>
